module.exports = __webpack_public_path__ + "img/dlt_kind_5.b47814f8.svg";